import styles from './styles.module.scss'
import { TierCard } from '../TierCard'

export const RatingTier = ({ attributes, backgroundColor }) => {
  const ratingKeys = ['oneToThree', 'fourToSix', 'sevenToNine', 'ten']

  return (
    <div className={styles.ratingTier}>
      <div className={styles.ratingTier__cardsWrapper}>
        {ratingKeys.map((key, index) => (
          <div key={index} className={styles.ratingTier__cardWrapper}>
            <TierCard
              index={index}
              content={attributes?.[key]}
              backgroundColor={backgroundColor}
            />
          </div>
        ))}
      </div>
      <article
        className={styles.ratingTier__content}
        dangerouslySetInnerHTML={{
          __html: attributes?.content,
        }}
      />
    </div>
  )
}
